import React from 'react';
import { makeStyles, Box } from '@material-ui/core';
import Typography from '#web-components/components/Typography';
import styles from './DescriptionBox.styles';

const useStyles = makeStyles(styles, { name: 'Description' });

export type DescriptionBoxProps = {
  icon?: React.ReactNode;
  description?: React.ReactNode | string;
};

export default function DescriptionBox({
  icon,
  description,
}: DescriptionBoxProps) {
  const classes = useStyles();

  return (
    <Box className={classes.descriptionBox}>
      {icon && <Box component="span" className={classes.icon}>{icon}</Box>}
      <Typography variant="textTiny">{description}</Typography>
    </Box>
  );
}
